import { Button } from "@/components/ui/button";
import { ShieldCheck, ArrowRight } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="relative pt-28 pb-20 lg:pt-36 lg:pb-28 overflow-hidden bg-offwhite">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left — Text */}
          <div className="space-y-8 animate-fade-up">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary font-body text-sm font-semibold">
              <ShieldCheck size={16} />
              Proteção inteligente para sua vida
            </div>

            <h1 className="font-heading font-extrabold text-2xl md:text-4xl lg:text-5xl leading-tight">
              Planeje suas conquistas
              <br />
              <span className="text-primary">e proteja sua família</span>.
            </h1>

            <p className="font-body text-muted-foreground text-lg max-w-md leading-relaxed">
              Na Tavares & Camilo, simplificamos a escolha do seu <span className="font-bold text-foreground">seguro</span>, <span className="font-bold text-foreground">consórcio</span> ou <span className="font-bold text-foreground">plano de saúde</span>.
            </p>

            <div className="flex flex-wrap gap-4">
              <a href="#contato">
                <Button variant="hero" size="xl">
                  Solicitar Cotação
                  <ArrowRight size={18} />
                </Button>
              </a>
              <a href="#servicos">
                <Button variant="outline" size="xl">
                  Nossos Serviços
                </Button>
              </a>
            </div>

            <div className="hidden md:flex items-center gap-6 pt-2 font-body text-sm text-muted-foreground">
              <span className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent" />
                +3.000 clientes protegidos
              </span>
              <span className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary" />
                Atendimento humanizado
              </span>
            </div>
          </div>

          {/* Right — Images */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://res.cloudinary.com/tatikka/image/upload/f_webp,w_1200,q_85/v1777481437/Seguro-para-Familia-Tavares-e-Camilo_xgk0y2.png"
                srcSet="https://res.cloudinary.com/tatikka/image/upload/f_webp,w_800,q_80/v1777481437/Seguro-para-Familia-Tavares-e-Camilo_xgk0y2.png 800w, https://res.cloudinary.com/tatikka/image/upload/f_webp,w_1200,q_85/v1777481437/Seguro-para-Familia-Tavares-e-Camilo_xgk0y2.png 1200w"
                sizes="(max-width: 768px) 800px, 1200px"
                alt="Família feliz em momento de lazer protegida pela corretora de seguros e saúde da Tavares & Camilo"
                width={1024}
                height={1024}
                decoding="sync"
                className="w-full rounded-3xl shadow-elevated object-cover aspect-square"
                fetchpriority="high"
              />
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-primary/10 rounded-2xl -z-10 blur-2xl" />
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-accent/10 rounded-full -z-10 blur-3xl" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
